const events_fields = `
			id
			name
			start_time
			end_time
			event_image_url
			location
			timezone
			timezone_display
			status
			custom_metadata_fields
			custom_metadata_attributes {
				key
				name
				category
			}
			homescreen_layout
			homescreen_widget_order
			homescreen_theme
			active_homescreen
			client_id
			created_at
			updated_at
			deleted_at
			single_page_app
			anonymous_login
			gamification
			admins {
				id
				email
			}
			owner_id
			payments {
				id
				seats
				paid
				expiration
			}
`;

export const EVENTS = `
	query events($client_id: Uint) {
		events(client_id: $client_id) {
			${events_fields}
		}
	}
`;

export const EVENTS_INCLUDING_DELETED = `
	query eventsIncludingDeleted($client_id: Uint) {
		eventsIncludingDeleted(client_id: $client_id) {
			${events_fields}
		}
	}
`;

export const EVENT = `
	query event($id: Uint) {
		event(id: $id) {
			id
			name
			start_time
			end_time
			status
			posts_require_approval
			theme
			event_image_url
			homescreen_layout
			homescreen_widget_order
			homescreen_theme
			active_homescreen
			custom_metadata_fields
			custom_metadata_attributes {
				key
				name
				category
			}
			attendee_count
			agenda_item_count
			analytics_id
			client_id
			side_navigation
			location
			timezone
			timezone_display
			single_page_app
			anonymous_login
			gamification
			avatar_points_enabled
			avatar_points_cap
			avatar_points_value
			login_points_enabled
			login_points_cap
			login_points_value
			hashtag_points_shown
			payments {
				id
				seats
				paid
				expiration
			}
			created_at
			updated_at
			deleted_at
			groups {
				id
				name
			}
			admins {
				id
				email
			}
			event_kudo {
				id
				attendee_kudo_title
				leaderboard_config
			}
			leaderboard_sources {
				id
				event_id
				name
				type
				type_id
			}
		}
	}
`;
